import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'base-ui/dist/Icon';

function Rating({ likes, likeRate }) {
  // eslint-disable-next-line radix
  const rate = parseInt(likeRate);
  return (
    <span className="meta regent-grey-color display-block full">
      <Icon prefix="fas" name="thumbs-up" />
      {` ${rate}% `}
      <strong>{` (${likes}) `}</strong>
    </span>
  );
}

Rating.propTypes = {
  likes: PropTypes.any,
  likeRate: PropTypes.number,
};

export default Rating;
